import type { BadgeTone } from '@/components/ui/Badge'
import type { IconName } from '@/components/ui/Icon'

export type StatusAppearance = { tone: BadgeTone; icon: IconName }

export type PartnerAccountStatus = 'PENDING_APPROVAL' | 'APPROVED' | 'REJECTED' | 'SUSPENDED'

export type ModerationStatus =
  | 'UPLOADED'
  | 'SCANNING'
  | 'SCAN_CLEAN'
  | 'SCAN_FLAGGED'
  | 'SCAN_FAILED'
  | 'READY'

export type PluginBuildStatus = 'REQUESTED' | 'BUILDING' | 'READY' | 'FAILED' | 'EXPIRED'

export const agentAppearance: Record<'online' | 'offline', StatusAppearance> = {
  online: { tone: 'success', icon: 'dot' },
  offline: { tone: 'neutral', icon: 'dotHollow' },
}

export const partnerAppearance: Record<PartnerAccountStatus, StatusAppearance> = {
  PENDING_APPROVAL: { tone: 'warning', icon: 'clock' },
  APPROVED: { tone: 'success', icon: 'check' },
  REJECTED: { tone: 'error', icon: 'xCircle' },
  SUSPENDED: { tone: 'error', icon: 'minusCircle' },
}

export const moderationAppearance: Record<ModerationStatus, StatusAppearance> = {
  UPLOADED: { tone: 'neutral', icon: 'upload' },
  SCANNING: { tone: 'warning', icon: 'spinner' },
  SCAN_CLEAN: { tone: 'success', icon: 'shieldCheck' },
  SCAN_FLAGGED: { tone: 'error', icon: 'alertTriangle' },
  SCAN_FAILED: { tone: 'neutral', icon: 'minusCircle' },
  READY: { tone: 'success', icon: 'check' },
}

export const pluginBuildAppearance: Record<PluginBuildStatus, StatusAppearance> = {
  REQUESTED: { tone: 'neutral', icon: 'clock' },
  BUILDING: { tone: 'warning', icon: 'spinner' },
  READY: { tone: 'success', icon: 'download' },
  FAILED: { tone: 'error', icon: 'alertTriangle' },
  EXPIRED: { tone: 'neutral', icon: 'clockOff' },
}
